export const DragScrollController = () => {

  let sliders = document.querySelectorAll('.products-block__slider');

  sliders.forEach(function (slider, index) {
    let container = slider.querySelector('.product-slider__inner');
    let slides = slider.querySelectorAll('.product-slider__slide');
    let width = slides[0].offsetWidth;
    let trackWidth = width * slides.length;
    let track = slider.querySelector('.product-slider__track');
    let draggerTrack = slider.querySelector('.product-slider-dragger');
    track.style.width = trackWidth + 'px';

    let dragger = slider;
    let x = 0, y = 0, top = 0, left = 0;

    if(checkOverflow(track)) {
      let draggingFunction = (e) => {
        document.addEventListener('mouseup', () => {
            document.removeEventListener("mousemove", draggingFunction);

        });

        container.scrollLeft = left - e.pageX + x;
        container.scrollTop = top - e.pageY + y;
      };

      dragger.addEventListener('mousedown', (e) => {
          e.preventDefault();
          e.stopPropagation();

          y = e.pageY;
          x = e.pageX;
          top = container.scrollTop;
          left = container.scrollLeft;

          document.addEventListener('mousemove', draggingFunction);
      });
    } else {
      draggerTrack.style.display = 'none';
    }

  });

}


const checkOverflow = (elem) => {
  const elemWidth = elem.getBoundingClientRect().width
  const parentWidth = elem.parentElement.getBoundingClientRect().width
  return elemWidth > parentWidth
}



// WEBPACK FOOTER //
// ./src/js/controllers/DragScrollController.js